import type { ReactNode } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import { IconButton } from '@/components/IconButton'
import { Icon } from '@/components/Icon'
import {
  DropdownTitle,
  DropdownItem,
  Dropdown,
  DropdownItemTitle,
} from '@/components/Dropdown'
import styles from './CollaboratorsCard.module.css'

export interface CollaboratorsCardProps {
  menu: ReactNode
  children: ReactNode
}

export function CollaboratorsCard({ menu, children }: CollaboratorsCardProps) {
  return (
    <Card>
      <CardHeader>
        <div className={styles.cardHeader}>
          <CardTitle testId="collaborators-tab-item">Collaborators</CardTitle>
          {menu}
        </div>
      </CardHeader>
      <CardContent scroll compact>
        {children}
      </CardContent>
    </Card>
  )
}

export interface CollaboratorsMenuProps {
  canAddCollaborator: boolean
  onAddCollaborator: () => void
  canAddClient: boolean
  onAddClient: () => void
  canRatePro: boolean
  onRatePro: () => void
  canRemoveCollaborator: boolean
  onRemoveCollaborator: () => void
  canRemoveClient: boolean
  onRemoveClient: () => void
}

export function CollaboratorsMenu({
  canAddCollaborator,
  onAddCollaborator,
  canAddClient,
  onAddClient,
  canRatePro,
  onRatePro,
  canRemoveCollaborator,
  onRemoveCollaborator,
  canRemoveClient,
  onRemoveClient,
}: CollaboratorsMenuProps) {
  return (
    <Dropdown
      autoDismiss
      testId="collaborators-card-dropdown-menu"
      button={
        <IconButton name="more" label="Collaborator actions" rotate={90} />
      }
    >
      <DropdownTitle>Actions</DropdownTitle>

      {canAddCollaborator && (
        <DropdownItem
          icon={<Icon name="add" />}
          onPress={onAddCollaborator}
          testId="collaborators-add-pro-dropdown-item"
        >
          <DropdownItemTitle>Add collaborator</DropdownItemTitle>
        </DropdownItem>
      )}

      {canAddClient && (
        <DropdownItem
          icon={<Icon name="add" />}
          onPress={onAddClient}
          testId="collaborators-add-client-dropdown-item"
        >
          <DropdownItemTitle>Add client</DropdownItemTitle>
        </DropdownItem>
      )}

      {canRatePro && (
        <DropdownItem
          icon={<Icon name="ratings" />}
          onPress={onRatePro}
          testId="collaborators-rate-pro-dropdown-item"
        >
          <DropdownItemTitle>Rate pro</DropdownItemTitle>
        </DropdownItem>
      )}

      {canRemoveCollaborator && (
        <DropdownItem
          icon={<Icon name="delete" />}
          onPress={onRemoveCollaborator}
          testId="collaborators-remove-pro-dropdown-item"
        >
          <DropdownItemTitle>Remove collaborator</DropdownItemTitle>
        </DropdownItem>
      )}

      {canRemoveClient && (
        <DropdownItem
          icon={<Icon name="delete" />}
          onPress={onRemoveClient}
          testId="collaborators-remove-clients-dropdown-item"
        >
          <DropdownItemTitle>Remove client</DropdownItemTitle>
        </DropdownItem>
      )}
    </Dropdown>
  )
}
